import type { RouteObject } from 'react-router-dom';

import FailurePage from '@features/reservation/pages/FailurePage';
import QrPage from '@features/reservation/pages/QrPage';
import DurationPage from '@features/reservation/pages/DurationPage';
import SuccessPage from '@features/reservation/pages/SuccessPage';
import PaymentPayNowStatus from '@features/reservation/pages/payment/PaymentPayNowStatus';
import ReservationPaymentFlowPage from '@features/reservation/pages/payment/ReservationPaymentFlowPage';
import ReservationFlowPage from '@features/reservation/pages/ReservationFlowPage';
import SpanPaymentLinkPage from '@features/reservation/pages/SpanPaymentLinkPage';
import SpanPaymentLinkResultPage from '@features/reservation/pages/SpanPaymentLinkResultPage';
import ParkingChosenGuard from '@features/reservation/guards/ParkingChosenGuard';
import { AuthGuard } from '@features/auth';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export const reservationRoutes: RouteObject[] = [
  {
    element: <AuthGuard allowGuest />,
    children: [
      {
        path: ROUTE_PATHS[RouteName.RESERVATION_FLOW],
        element: <ReservationFlowPage />,
      },
      {
        path: ROUTE_PATHS[RouteName.RESERVATION_PAYMENT],
        element: <ReservationPaymentFlowPage />,
      },
    ],
  },
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_PAYMENT_STATUS_SUCCESS],
    element: <PaymentPayNowStatus success />,
  },
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_PAYMENT_STATUS_FAILURE],
    element: <PaymentPayNowStatus />,
  },
  // The payment link from the reminder email works without a session: it stays outside every AuthGuard.
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_SPAN_PAYMENT_LINK],
    element: <SpanPaymentLinkPage />,
  },
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_SPAN_PAYMENT_LINK_SUCCESS],
    element: <SpanPaymentLinkResultPage success />,
  },
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_SPAN_PAYMENT_LINK_FAILURE],
    element: <SpanPaymentLinkResultPage />,
  },
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_SUCCESS],
    element: <SuccessPage />,
  },
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_FAILURE],
    element: <FailurePage />,
  },
  {
    path: ROUTE_PATHS[RouteName.RESERVATION_DURATION],
    element: <DurationPage />,
  },
  {
    element: <ParkingChosenGuard />,
    children: [
      {
        path: ROUTE_PATHS[RouteName.RESERVATION_QR],
        element: <QrPage />,
      },
    ],
  },
];
